import React from 'react';
import Card from '../Card';

export default function ShuffleCardsAnimated(props) {
  let cards = [];

  for (let [i, cardType] of props.cards.entries()) {
    cards.push(
      <Card
        key={`shuffling-card-${i}`}
        type={cardType}
        animating={true}
        movementType={props.movementType}
      />
    )
  }

  return <div id="shuffle-cards-card-container">
    <div id="shuffle-cards-card-wrap">
      {cards}
    </div>
  </div>
}
